module.exports = __webpack_public_path__ + "img/backdrafts.26d02940.png";